import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import EULogoBanner from './components/EULogoBanner';
import EUProjectHero from './components/EUProjectHero';
import EUProjectInfo from './components/EUProjectInfo';
import ResearchProject from './components/ResearchProject';

export default function EUProjectsPage() {
  return (
    <div className="min-h-screen bg-[#050505]">
      {/* Banner z logotypami UE - na samej górze, przed nawigacją */}
      <EULogoBanner />
      <Navigation />
      <main>
        <EUProjectHero />
        {/* Projekt Badawczy jako pierwszy */}
        <ResearchProject />
        {/* Projekt wdrożeniowy jako drugi */}
        <EUProjectInfo />
      </main>

      {/* Dolny banner logotypów UE przed stopką */}
      <section className="bg-white py-4 sm:py-6 border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="flex flex-row items-center justify-center gap-4 sm:gap-6 md:gap-10">
            <div className="flex items-center gap-1.5 sm:gap-2">
              <div className="w-7 h-7 sm:w-9 sm:h-9 flex items-center justify-center rounded-full bg-[#003399]">
                <span className="text-[#FFD700] text-[9px] sm:text-xs font-bold" style={{ fontFamily: 'Inter, sans-serif' }}>FE</span>
              </div>
              <span className="text-[#003399] text-[8px] sm:text-[10px] font-semibold" style={{ fontFamily: 'Inter, sans-serif' }}>
                Fundusze Europejskie
              </span>
            </div>
            <div className="w-px h-6 sm:h-8 bg-gray-300"></div>
            <div className="flex items-center gap-1.5 sm:gap-2">
              <div className="w-9 h-6 sm:w-12 sm:h-8 flex items-center justify-center rounded bg-[#003399] relative">
                <div className="relative w-4 h-4 sm:w-6 sm:h-6">
                  {Array.from({ length: 12 }).map((_, i) => {
                    const angle = (i * 30 - 90) * (Math.PI / 180);
                    const x = 50 + 38 * Math.cos(angle);
                    const y = 50 + 38 * Math.sin(angle);
                    return (
                      <span
                        key={i}
                        className="absolute text-[#FFD700] text-[4px] sm:text-[5px] leading-none"
                        style={{
                          left: `${x}%`,
                          top: `${y}%`,
                          transform: 'translate(-50%, -50%)',
                        }}
                      >
                        ★
                      </span>
                    );
                  })}
                </div>
              </div>
              <span className="text-[#003399] text-[8px] sm:text-[10px] font-semibold" style={{ fontFamily: 'Inter, sans-serif' }}>
                Unia Europejska
              </span>
            </div>
          </div>
          <p className="text-center text-[#888] text-[8px] sm:text-[10px] mt-2 sm:mt-4" style={{ fontFamily: 'Inter, sans-serif' }}>
            Projekt współfinansowany ze środków Europejskiego Funduszu Rozwoju Regionalnego
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}
